// for retyr payment  of employee
export const RESET_RETRY_PAYMENT = "resign_retry_payment";
export const RETRY_PAYMENT = "retry_payment";
export const RETRY_PAYMENT_SUCCESS = "retry_payment_success";
export const RETRY_PAYMENT_FAILURE = "retry_payment_failure";
